<template>
  <transition name="slide-form">
    <div
      class="cardHolder"
      :style="{ zoom: `1.${getWebchat().client.accessibility.fontSize}` }"
    >
      <v-card
        v-if="getVisibleForm"
        v-show="showInputs"
        class="main-form-div"
        :style="{
          'border-top': '2px solid ' + getWebchat().campaign.color + '60',
        }"
      >
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-text-field
              ref="namefield"
              @keyup.enter="$refs.emailfield.focus"
              :label="$t('name')"
              :rules="[() => !!client.name || $t('musttypename')]"
              :error="errorCheck && client.name == ''"
              :style="{
                color: getWebchat().campaign.color,
              }"
              class="form-input input-style first-input"
              prepend-icon="mdi-account"
              v-model="client.name"
              required
            ></v-text-field>
          </v-flex>
          <v-flex
            v-if="getWebchat().campaign.show_email"
            xs12
            sm12
            md12
            lg12
            xl12
          >
            <v-text-field
              ref="emailfield"
              @keyup.enter="$refs.customfield.focus"
              :label="$t('email')"
              :rules="[
                () => !!client.mail || $t('musttypemail'),
                () => emailRegex.test(client.mail) || $t('validemail'),
              ]"
              :error="errorCheck && client.mail == ''"
              :style="{
                color: getWebchat().campaign.color,
              }"
              class="form-input input-style"
              prepend-icon="mdi-mail"
              v-model="client.mail"
              required
            ></v-text-field>
          </v-flex>
          <v-flex
            v-if="getWebchat().campaign.custom_field.visible"
            xs12
            sm12
            md12
            lg12
            xl12
          >
            <v-text-field
              ref="customfield"
              @keyup.enter="$refs.messagefield.focus"
              prepend-icon="mdi-label"
              :label="
                getWebchat().campaign.custom_field.text[
                  getWebchat().client.lang
                ]
              "
              :error="
                errorCheck &&
                getWebchat().campaign.custom_field.required &&
                client.number == ''
              "
              :required="getWebchat().campaign.custom_field.required"
              :style="{
                color: getWebchat().campaign.color,
              }"
              class="form-input input-style"
              v-model="client.number"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md12 lg12 xl12>
            <v-textarea
              ref="messagefield"
              :label="$t('message')"
              @keyup.native.13="clickForm"
              :rules="[() => !!client.initialMessage || $t('musttypemessage')]"
              :error="errorCheck && client.initialMessage == ''"
              :style="{
                color: getWebchat().campaign.color,
              }"
              class="form-input input-style"
              prepend-icon="mdi-chat"
              v-model="client.initialMessage"
              required
              auto-grow
              rows="1"
            ></v-textarea>
          </v-flex>

          <v-btn
            rounded
            small
            width="100%"
            @click="clickForm"
            :style="{
              'background-color': getWebchat().campaign.color,
            }"
            id="btnEnviar"
          >
            <span
              :style="{
                color: invertColor(getWebchat().campaign.color),
              }"
              style="font-size: 2.8vw"
              >{{
                getWebchat().campaign.available
                  ? $t("newConversation")
                  : $t("sendMessage")
              }}
              &nbsp;</span
            >
            <Send :color="invertColor(getWebchat().campaign.color)" />
          </v-btn>
        </v-layout>
      </v-card>
    </div>
  </transition>
</template>

<script>
import { generateUUID, invertColor } from "@/assets/utils";
import Send from "./../assets/send";
import Constants from "../assets/Constants";

export default {
  name: "main-form",
  components: {
    Send,
  },
  data() {
    return {
      showInputs: true,
      client: {
        name: "",
        mail: "",
        number: "",
        message: "",
        initialMessage: "",
        data: "",
        lang:"",
      },
      window: window,
      emailRegex: new RegExp(/\S+@\S+\.\S+/),
      messageSended: false,
      errorCheck: false,
      Send,
    };
  },

  computed: {
    getVisibleForm() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      let campaign = this.$store.state[index].campaign;
      //if is the campaign is ready to new interactions
      if (
        campaign.onTime &&
        campaign.avaiableAgents &&
        campaign.avaiableInteractions
      )
        return true;
      //else return the showmessage option
      else return campaign.showMessage;
    },
  },

  created() {
    this.$store.commit("changeImage", "");
    this.getInitialInfo();
  },

  mounted() {
    this.$store.commit("noStartedInteraction");
    this.$store.commit("newGuid");
    this.$store.commit("clearInitialMessage");
    this.$store.commit("clearInteraction");

    window.parent.postMessage({ action: "WEBCHAT_READY" }, "*");
  },

  methods: {
    invertColor,

    /**
     * @name GET_INITIAL_INFO
     * @desc Gets info from store to use in this component
     */
    getInitialInfo() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      let client = this.$store.state[index].client;
      this.client.name = client.name;
      this.client.number = client.number;
      this.client.lang = client.lang

      if (client.mail.indexOf("no-domain") == -1) {
        this.client.mail = client.mail;
      }
    },

    /**
     * @name CLICK_FORM
     * @desc Checks form info and re-routes to /chat
     */
    clickForm() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      let campaign = this.$store.state[index].campaign;
      let { name, initialMessage, mail, number } = this.client;
      let pattern = new RegExp(
        "^([a-zA-ZàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ0-9_.@ -])+$"
        );
      const serializedState = localStorage.getItem('vuex');

      if (serializedState) {
        const newState = JSON.parse(serializedState);
        this.$store.commit('updateVuex', newState);
      }
      let state = this.$store.state[index].interaction.state
        if (
          state === Constants.WAITING_STATE ||
          state === Constants.STARTED_STATE
        ) {
          this.$router.push({
        path: "chat",
        query: {
          campaign: campaignName,
        },
      });
        }else {

          this.client.data = this.$store.state[index].configuration.data;
          if (
            name &&
            pattern.test(name) &&
            initialMessage &&
            (!number || pattern.test(number))
          ) {

            if (
              (campaign.show_email &&
                mail &&
                pattern.test(mail) &&
                this.emailRegex.test(mail)) ||
              !campaign.show_email
            ) {
              if (
                (campaign.custom_field.required && number) ||
                !campaign.custom_field.required
              ) {
                if (campaign.onTime && campaign.available) {
                  if (!campaign.show_email) {
                    this.client.mail = generateUUID() + "@no-domain.com";
                  }
                  this.sendTochat();
                } else {
                  this.sendMessageOffline();
                }
              } else {
                this.$toast.bottom(this.$t("fieldserror"));
                this.errorCheck = true;
              }
            } else {
              this.errorCheck = true;
              this.$toast.bottom(this.$t("emailerror"));
            } 
        } else {
              this.$toast.bottom(this.$t("fieldserror"));
              this.errorCheck = true;
          }
    }
    },

    /**
     * @name SEND_MESSAGE_OFFLINE
     * @desc Sends offline message back to server in case the
     *       campaign is out of time or has no agents
     */
    async sendMessageOffline() {
      const campaignName = this.$route.query.campaign;

      const index = this.$store.state.findIndex(
        (e) => e.configuration.campaign === campaignName
      );

      if (!this.messageSended) {
        this.messageSended = true;
        this.client.campaign = this.$store.state[index].configuration.campaign;
        try {
          await this.$http.get(
            "https://" +
              this.$store.state[index].configuration.ip +
              "/IntegraChannels/resources/webchat/sendOfflineMessage",
            { params: this.client }
          );
          this.showInputs = false;
          this.$toast.bottom(this.$t("messagesended"));
        } catch (error) {
          this.$toast.bottom(this.$t("messageserror"));
          console.log(error);
        }
      }
    },

    /**
     * @name SEND_TO_CHAT
     * @desc Saves client info to store and re-routes to chat
     */
    sendTochat(e) {
      const campaignName = this.$route.query.campaign;

      this.$store.commit("setClientInfo", this.client);
      this.$store.commit("newGuid");
      this.$router.push({
        path: "chat",
        query: {
          campaign: campaignName,
        },
      });
    },

    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },
  },
};
</script>

<style scoped>
/* Pages Transitions */
.slide-form-enter-active {
  transition: all 0.3s ease;
  opacity: 1;
}

.slide-form-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-form-enter,
.slide-form-leave-to {
  transform: translateY(50px);
  opacity: 0;
}

.input-group__details:before {
  background-color: rgba(0, 0, 0, 0.12) !important;
}

.showCenterWelcome {
  position: absolute;
  left: 0;
  top: calc(50% - 16px);
  font-size: 1.3em !important;
}

#holderOnTime {
  width: 100%;
  margin: auto;
  padding-top: 1em;
  font-size: 1em;
  color: rgba(0, 0, 0, 0.31);
  margin-bottom: 1em;
  display: flex;
  justify-content: center;
  overflow-y: scroll;
  max-height: 25%;
}

.card-border-radius {
  border-radius: 6px 6px 0 0;
}

.cardHolder {
  margin-top: -96px;
}

.cardHolder-mobile {
  margin-top: 0;
}

.holderInputs {
  width: 100%;
  height: 100%;
  font-size: 17.5px;
  background-color: #fff;
  overflow-y: scroll;
  margin-top: 0%;
  height: 100%;
  margin-bottom: 0;
  padding: 33px;
  border-radius: 6px;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
}

@media screen and (min-device-aspect-ratio: 16/10) {
  .holderInputs {
    margin-top: 0%;
    height: 100%;
    margin-bottom: 0;
  }
}

#btnEnviar {
  width: 199px;
  margin: auto;
  display: block;
  font-weight: 400;
  color: white;
  height: 41px;
  margin-top: 27px;
  cursor: pointer;
}

.input-style {
  margin-bottom: -10px;
}

.first-input {
  margin-top: -13px !important;
  margin-bottom: -2px !important;
}

.md-input-container {
  width: 92%;
  min-height: 48px;
  margin: 4px 0 24px;
  padding-top: 19px;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

.md-input-container textarea {
  max-height: 50px;
  overflow-y: scroll;
}

.md-input-container {
  margin-bottom: 15px;
}

@-moz-document url-prefix() {
  .holderInputs {
    margin-bottom: 84px;
    height: 85%;
  }
}

.mobile-sizes {
  height: 100%;
  margin-bottom: 0;
  margin-top: 0;
  position: absolute;
}

.not-abiable-message {
  top: 40% !important;
}

.not-abiable-message p {
  height: 100%;
  word-wrap: break-word;
  overflow-x: hidden;
  width: 90%;
}

.margin-right-vw1 {
  margin-right: 1vw;
}

.cardHolder-hidden {
  height: 0 !important;
}

.holder-inputs-lowRes {
  height: 100% !important;
}

.card-holder-lowRes {
  margin-top: 0 !important;
}

.main-form-div {
  padding: 53px 37px 34px 37px;
  z-index: 10;
  margin: 20px;
  margin-top: 25px;
  border-radius: 4px;
  border-top: 2px solid rgba(255, 255, 255, 0.6);
}

.main-form-div .flex {
  margin-bottom: 8px;
}

.hide-win-scroll {
  overflow: hidden;
}
</style>
